import axios from "../config";
import { getRefreshToken } from "@utility/storage/auth";

export const getUserProfile = (jwt) => {
  return axios.get("/user/me", {
    headers: { Authorization: `Bearer ${jwt}` },
  });
};

export const getUserById = (jwt, userId) => {
  return axios.get(`/user/${userId}`, {
    headers: { Authorization: `Bearer ${jwt}` },
  });
};

export const logoutRequest = (refreshToken) => {
  return axios.post("/user/logout", {
    refreshToken: refreshToken || getRefreshToken() || undefined,
  });
};
